/**
 * messagesData.js — seed data for the Messages page, ported verbatim from
 * the original's `allThreads` object (both the "user" and "support"
 * inboxes, including every thread's full message history).
 *
 * Swap `initialThreads` for a real API call (e.g. getThreads()) when
 * wiring this up. `PER_PAGE` matches the original's hardcoded page size.
 */

export const PER_PAGE = 8;

export const initialThreads = {
  user: [
    {
      id: 1,
      subject: "Testing How I Can Send a Message",
      sender: "Henry Doe",
      email: "henrydimo+14@gmail.com",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Sep 09, 2025",
      timestamp: "3:42 PM",
      preview:
        "Thank you for your email, but I wanted to clarify a few details…",
      unread: true,
      color: 0,
      messages: [
        {
          from: "Henry Doe",
          initials: "HD",
          time: "Sep 9, 2025 · 3:12 PM",
          text: "Hi there! I just wanted to test the messaging feature. Can you confirm you received this message? Looking forward to working with Awasource.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Sep 9, 2025 · 3:42 PM",
          text: "Thank you for your email, but I wanted to clarify a few details before we proceed. Could you share more about the role you're looking to fill?",
          outgoing: true,
        },
        {
          from: "Henry Doe",
          initials: "HD",
          time: "Sep 9, 2025 · 4:05 PM",
          text: "Of course! We are looking for a senior front-end developer with React experience. The role is fully remote, 6-month contract.",
          outgoing: false,
        },
      ],
    },
    {
      id: 2,
      subject: "React Developer Opportunity",
      sender: "Sarah Kimani",
      email: "sarahk@techcorp.io",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Sep 07, 2025",
      timestamp: "11:20 AM",
      preview:
        "We have an urgent opening and would like to discuss candidates…",
      unread: true,
      color: 2,
      messages: [
        {
          from: "Sarah Kimani",
          initials: "SK",
          time: "Sep 7, 2025 · 11:20 AM",
          text: "We have an urgent opening and would like to discuss candidates available for immediate start. Please let us know your availability for a quick call.",
          outgoing: false,
        },
      ],
    },
    {
      id: 3,
      subject: "Interview Scheduling — James Osei",
      sender: "James Osei",
      email: "jamesosei@mail.com",
      type: "Talent",
      badgeClass: "badgeTalent",
      date: "Sep 05, 2025",
      timestamp: "9:00 AM",
      preview: "I am available Wednesday or Friday for the interview…",
      unread: false,
      color: 4,
      messages: [
        {
          from: "James Osei",
          initials: "JO",
          time: "Sep 5, 2025 · 9:00 AM",
          text: "Good morning! I wanted to reach out regarding the interview for the UX Designer position. I am available Wednesday or Friday this week. Please confirm which works for you.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Sep 5, 2025 · 10:15 AM",
          text: "Hello James, Wednesday at 2 PM works perfectly. I will send a calendar invite shortly. Thank you!",
          outgoing: true,
        },
      ],
    },
    {
      id: 4,
      subject: "Contract Renewal — Quarterly Review",
      sender: "TechBridge Ltd.",
      email: "contracts@techbridge.co",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Aug 28, 2025",
      timestamp: "2:30 PM",
      preview: "Please review the attached contract terms for Q4 renewal…",
      unread: false,
      color: 3,
      messages: [
        {
          from: "TechBridge Ltd.",
          initials: "TB",
          time: "Aug 28, 2025 · 2:30 PM",
          text: "Please review the attached contract terms for Q4 renewal. We have made minor adjustments to the billing cycle. Let us know if you have any questions.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Aug 28, 2025 · 4:00 PM",
          text: "Thank you for sending this over. We will review and get back to you by end of week.",
          outgoing: true,
        },
      ],
    },
    {
      id: 6,
      subject: "Onboarding Documents Required",
      sender: "Lena Müller",
      email: "lena.muller@startupxyz.de",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Aug 20, 2025",
      timestamp: "8:55 AM",
      preview: "Please send the signed NDA and tax forms before Monday…",
      unread: false,
      color: 1,
      messages: [
        {
          from: "Lena Müller",
          initials: "LM",
          time: "Aug 20, 2025 · 8:55 AM",
          text: "Hi! Could you please send the signed NDA and tax forms before Monday? We need them to complete the onboarding for your candidates.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Aug 20, 2025 · 9:30 AM",
          text: "Absolutely, we will have those documents to you by Friday. Thank you for the reminder.",
          outgoing: true,
        },
      ],
    },
    {
      id: 7,
      subject: "Follow-up on Shortlisted Candidates",
      sender: "Damilola Adeyemi",
      email: "d.adeyemi@novaltd.ng",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Aug 15, 2025",
      timestamp: "1:10 PM",
      preview:
        "We reviewed your shortlist and would like to proceed with two candidates…",
      unread: false,
      color: 2,
      messages: [
        {
          from: "Damilola Adeyemi",
          initials: "DA",
          time: "Aug 15, 2025 · 1:10 PM",
          text: "We reviewed your shortlist and would like to proceed with two candidates — Ama Boateng and Kwame Asante. Please arrange interviews for next week.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Aug 15, 2025 · 2:45 PM",
          text: "Great choice! I will coordinate with both candidates and send over proposed interview slots by tomorrow morning.",
          outgoing: true,
        },
      ],
    },
    {
      id: 8,
      subject: "Platform Feedback — Great Experience",
      sender: "Yuki Tanaka",
      email: "yuki.t@digitalmind.jp",
      type: "Talent",
      badgeClass: "badgeTalent",
      date: "Aug 10, 2025",
      timestamp: "6:20 PM",
      preview:
        "Just wanted to say the platform made the whole job search so easy…",
      unread: false,
      color: 4,
      messages: [
        {
          from: "Yuki Tanaka",
          initials: "YT",
          time: "Aug 10, 2025 · 6:20 PM",
          text: "Just wanted to say the platform made the whole job search so easy. I landed a role within 3 weeks! Thank you Awasource.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Aug 10, 2025 · 6:45 PM",
          text: "That is wonderful to hear, Yuki! Congratulations on the new role. We're so glad Awasource helped. Wishing you all the best!",
          outgoing: true,
        },
      ],
    },
    {
      id: 9,
      subject: "Invoice #2048 — Payment Confirmation",
      sender: "Bright Mensah",
      email: "b.mensah@accelgroup.com",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Aug 05, 2025",
      timestamp: "4:00 PM",
      preview:
        "Payment for invoice #2048 has been processed. Please confirm receipt…",
      unread: false,
      color: 3,
      messages: [
        {
          from: "Bright Mensah",
          initials: "BM",
          time: "Aug 5, 2025 · 4:00 PM",
          text: "Payment for invoice #2048 has been processed from our end. Please confirm receipt and let us know when the next batch of CVs will be ready.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Aug 5, 2025 · 4:22 PM",
          text: "Payment confirmed, thank you! The next batch of curated profiles will be ready by August 8th. We will send them directly to your email.",
          outgoing: true,
        },
      ],
    },
    // ── Page 2 threads ──
    {
      id: 10,
      subject: "Senior Data Analyst — Urgent Fill",
      sender: "Amara Sesay",
      email: "amara@fintech-pros.io",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Jul 30, 2025",
      timestamp: "10:00 AM",
      preview:
        "We need to fill this role by mid-August, can you send profiles?…",
      unread: false,
      color: 0,
      messages: [
        {
          from: "Amara Sesay",
          initials: "AS",
          time: "Jul 30, 2025 · 10:00 AM",
          text: "We need to fill the Senior Data Analyst role by mid-August. It is quite urgent. Can you send relevant profiles by end of this week?",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Jul 30, 2025 · 11:30 AM",
          text: "Understood! We have several strong candidates in our pipeline. I will curate the top five and send them to you by Thursday.",
          outgoing: true,
        },
      ],
    },
    {
      id: 11,
      subject: "Background Check Status Update",
      sender: "Kofi Boateng",
      email: "kofi.b@verifytech.gh",
      type: "Talent",
      badgeClass: "badgeTalent",
      date: "Jul 24, 2025",
      timestamp: "3:15 PM",
      preview:
        "Just checking in on the background check — it has been two weeks…",
      unread: false,
      color: 4,
      messages: [
        {
          from: "Kofi Boateng",
          initials: "KB",
          time: "Jul 24, 2025 · 3:15 PM",
          text: "Hi, I just wanted to check in on the background verification process. It has been two weeks and I have not received any update.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Jul 24, 2025 · 4:00 PM",
          text: "Hi Kofi, apologies for the delay. I have just chased our verification partner — you should have a result within 48 hours. We'll keep you posted.",
          outgoing: true,
        },
      ],
    },
    {
      id: 12,
      subject: "Partnership Proposal — Staffing Agency",
      sender: "Nneka Obi",
      email: "nneka@obishire.ng",
      type: "Client",
      badgeClass: "badgeClient",
      date: "Jul 18, 2025",
      timestamp: "9:45 AM",
      preview:
        "We would love to explore a bulk staffing partnership with Awasource…",
      unread: false,
      color: 2,
      messages: [
        {
          from: "Nneka Obi",
          initials: "NO",
          time: "Jul 18, 2025 · 9:45 AM",
          text: "We would love to explore a bulk staffing partnership with Awasource for our clients across West Africa. Would you be open to a call this week?",
          outgoing: false,
        },
      ],
    },
    {
      id: 13,
      subject: "Candidate Withdrawal — Role Declined",
      sender: "Fatou Diallo",
      email: "f.diallo@prospects.sn",
      type: "Talent",
      badgeClass: "badgeTalent",
      date: "Jul 12, 2025",
      timestamp: "2:00 PM",
      preview:
        "Unfortunately I have decided to decline the offer at this time…",
      unread: false,
      color: 1,
      messages: [
        {
          from: "Fatou Diallo",
          initials: "FD",
          time: "Jul 12, 2025 · 2:00 PM",
          text: "I wanted to let you know that after careful consideration, I have decided to decline the offer at this time. I have accepted a position closer to home. Thank you for the opportunity.",
          outgoing: false,
        },
        {
          from: "You",
          initials: "AW",
          time: "Jul 12, 2025 · 2:30 PM",
          text: "Thank you for letting us know, Fatou. We completely understand. We wish you all the best in your new role and hope to work with you again in the future.",
          outgoing: true,
        },
      ],
    },
  ],
  support: [
    {
      id: 5,
      subject: "Issue with Job Posting Visibility",
      sender: "Support Team",
      email: "support@awasource.com",
      type: "Support",
      badgeClass: "badgeSupport",
      date: "Sep 10, 2025",
      timestamp: "10:05 AM",
      preview:
        "We have received your report and are looking into the visibility issue…",
      unread: false,
      color: 1,
      messages: [
        {
          from: "You",
          initials: "AW",
          time: "Sep 10, 2025 · 9:45 AM",
          text: "Hi Support, our latest job posting for Senior Engineer doesn't appear in public search results even after 24 hours. Could you please investigate?",
          outgoing: true,
        },
        {
          from: "Support Team",
          initials: "ST",
          time: "Sep 10, 2025 · 10:05 AM",
          text: "We have received your report and are looking into the visibility issue. Our team will update you within 2 business hours. Ticket #AWA-2041 has been created for tracking.",
          outgoing: false,
        },
      ],
    },
    {
      id: 14,
      subject: "Billing Discrepancy — July Invoice",
      sender: "Support Team",
      email: "billing@awasource.com",
      type: "Support",
      badgeClass: "badgeSupport",
      date: "Aug 02, 2025",
      timestamp: "11:00 AM",
      preview: "We have reviewed your July invoice and found a discrepancy…",
      unread: true,
      color: 3,
      messages: [
        {
          from: "You",
          initials: "AW",
          time: "Aug 2, 2025 · 10:30 AM",
          text: "Hi, I noticed the July invoice shows a charge for 12 job postings but we only published 9. Could someone review this please?",
          outgoing: true,
        },
        {
          from: "Support Team",
          initials: "ST",
          time: "Aug 2, 2025 · 11:00 AM",
          text: "We have reviewed your July invoice and found a discrepancy. A credit of $45 will be applied to your next billing cycle. Apologies for the inconvenience.",
          outgoing: false,
        },
      ],
    },
  ],
};

/** getInitials('Henry Doe') -> 'HD'. Ported verbatim from getInitials(). */
export function getInitials(name) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

/**
 * Splits a "Sep 9, 2025 · 3:12 PM" time string into its day-separator
 * label and bubble-time text, ported from the ` · ` split used in
 * buildConversation().
 */
export function splitMessageTime(time) {
  const [day, clock] = time.split(" · ");
  return { day, clock };
}

/** Ported verbatim from sendReply()/sendModalReply()'s date/time formatting. */
export function formatNowForMessage() {
  const now = new Date();
  const timeStr = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const dateStr = now.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return { timeStr, dateStr, combined: `${dateStr} · ${timeStr}` };
}
